import { $_app_server } from '@/_helpers'
import { checkResponse } from '@/_helpers'
export const userService = {
  getProfileinfo,
  getCard,
  changeProfileInfo
}

function getProfileinfo() {
  return $_app_server.get(`/api-getProfileinfo`).then(response => (checkResponse(response.data)))
}

function getCard() {
  return $_app_server.get(`/api-maxBalanceCard`).then(response => (checkResponse(response.data)))
}

function changeProfileInfo(obj) {
  return $_app_server.get(`/api-changeProfileInfo?obj=${obj.profileUuid}&type=${obj.type}&value=${obj.value}`).then(response => (checkResponse(response.data)))
}